import {TabState, TabStateDefaults} from 'Navigation';

export default class LocationTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Metadata',
      closeable: false,
      preferenceKey: 'location-tab',
    };
  }
}
